
  import search from "@/mixins/search";

  export default {
    name: "PropertyUnitCategorySuggestion",
    props: {
      unitCategory: {
        type: Object,
        required: true,
      }
    },
    mixins: [
      search,
    ],
    data() {
      return {
        months: [],
        isOpenGallery: false,
        isOpenUnitCategoryInfo: false,
        selectedStartDate: null,
        selectedStartDateMinStay: null,
        selectedEndDate: null,
        selectingStyleDates: [],
        selectedTotalAmount: 0,
        currentHoverCell: null,
        currentSlider: 0,
      };
    },
    methods: {
      formatDayCell(data) {
        if (!data.is_future_date) {
          return 'has-background-light has-text-grey suggestion-disabled';
        }

        if (!data.is_available) {
          return 'has-text-danger has-background-danger-light suggestion-disabled';
        }

        if (data.cta) {
          return 'has-background-success-light restriction-cta';
        }

        return 'has-background-success-light';
      },
      openGallery() {
        this.isOpenGallery = true;
      },
      isDateSelectable(data, isStart = false) {
        const isInSelectable = this.selectableDates.includes(data.date) || !this.selectableDates.length;

        if (isStart) {
          
          const isFutureDate = this.$moment(data.date).isSameOrAfter(new Date(), "day");
          const minStay = data.min_stay || 1; // Ensure minStay has a default value
          const maxStay = 60; // Set a reasonable maximum stay limit to prevent infinite loops
          let validCheckoutFound = false;
          let index = this.suggestionCalendar.findIndex(item => item.date === data.date);

          for (let stay = minStay; stay <= maxStay; stay++) {
            let checkoutIndex = index + stay;
            if (checkoutIndex >= this.suggestionCalendar.length) {
              break; // Reached the end of the calendar data
            }

            let checkoutData = this.suggestionCalendar[checkoutIndex];

            if (!checkoutData || checkoutData.availability === 0) {
              // No availability on this date, stop the search
              validCheckoutFound = false;
              break;
            }

            if (checkoutData.ctd) {
              // Checkout denied on this date, continue to next date
              continue;
            } else {
              // Found a valid checkout date
              validCheckoutFound = true;
              break;
            }
          }
          
          return !data.cta && data.is_available && isInSelectable && isFutureDate && validCheckoutFound;
        }
        
        return !data.ctd && isInSelectable;
      },

      selectDate(data) {
        if(!this.isDateSelectable(data, !this.selectedStartDate) && !this.selectedEndDate) {
          this.$buefy.toast.open({
              duration: 5000,
              message: this.$t('main.suggestions.not_selectable', { day: data.day_formatted}),
              position: 'is-bottom',
              type: 'is-danger'
          });

          return;
        }

        if (!this.selectedStartDate || !!this.selectedEndDate) {
          this.selectedStartDate = data.date;
          this.selectedStartDateMinStay = data.min_stay;
          this.selectedEndDate = null;

          return;
        }

        this.selectedEndDate = data.date;
        this.rangeConfirm()
      },
      rangeConfirm() {
        this.filters.start_date = this.selectedStartDate;
        this.filters.end_date = this.selectedEndDate;
        this.submitSearch({
          id: this.$route.params.id,
          single: true,
          combinations: true,
          redirect: 'single'
        });
      },
      rangeCancel() {
        this.selectedStartDate = null;
        this.selectedStartDateMinStay = null;
        this.selectedEndDate = null;
      },
      setSelectedRange(data) {
        if (!this.isSelecting || !this.selectableDates.includes(data.date)) {
          return [];
        }

        const start = this.$moment(this.selectedStartDate);
        const current = this.$moment(data.date);
        const selectingStyleDates = [];

        while (start.isSameOrBefore(current)) {
          selectingStyleDates.push(start.format('YYYY-MM-DD'));
          start.add(1, 'day');
        }

        this.selectingStyleDates = selectingStyleDates;
        this.calculateTotalAmount(data.date);
        this.currentHoverCell = data.date;
      },
      calculateTotalAmount(endDate) {
        this.selectedTotalAmount = 0;
        let index = this.suggestionCalendar.findIndex(item => item.date === this.selectedStartDate);
        let date = this.$moment(this.suggestionCalendar[index].date);

        do {
          this.selectedTotalAmount += parseFloat(this.suggestionCalendar[index].amount);
          date.add(1, 'day');
          index++;
        } while (date.isBefore(this.$moment(endDate)));
      },
      removeStyleDate() {
        if(!this.isSelecting) {
          return;
        }
        this.selectingStyleDates = []
        this.currentHoverCell = null
      },
      moveSliderF(steps, sliderLength) {
        const newSliderPosition = this.currentSlider + steps;
        const maxSliderPosition = sliderLength - (steps - 1);

        if (newSliderPosition <= maxSliderPosition) {
          this.currentSlider = newSliderPosition;
        } else {
          this.currentSlider = maxSliderPosition;
          this.$buefy.toast.open('Effettua una nuova ricerca per mostrare altre date disponibili');
        }

        return this.currentSlider;
      },
      moveSliderB(steps, sliderLength) {
        const newSliderPosition = this.currentSlider - steps;
        
        if (newSliderPosition >= 0 && newSliderPosition >= sliderLength) {
          this.currentSlider = newSliderPosition;
        } else {
          this.currentSlider = 0;
          this.$buefy.toast.open('Effettua una nuova ricerca per mostrare altre date disponibili');
        }

        return this.currentSlider;
      }
    },
    computed: {
      isSuggestionsLoaded() {
        return !!this.unitCategory.suggestions.length;
      },
      maxGuestCount() {
        return this.unitCategory.max_occupation;
      },
      suggestionCalendar() {
        const { start_date } = this.searchFilters;
        const isValidDate = this.$moment(start_date).isValid();
        const checkIn = isValidDate ? this.$moment(start_date) : this.$moment();
        const today = this.$moment();
        const start = checkIn.subtract(1, 'week').isBefore(today) ? today : checkIn;
        const end = this.$moment(start).add(2, 'month').endOf('month');

        const startDate = this.isSimpleView ? start : start.startOf('month');
        const days = [];

        let currentDate = startDate.clone();

        while (currentDate.isBefore(end)) {
          const currentMonth = currentDate.month();
          if (currentMonth !== currentDate.clone().subtract(1, 'day').month()) {
            days.push({
              separator: true,
              day_formatted: currentDate.format('MMMM'),
            });
          }

          // Ottieni tutte le suggerimenti per la data corrente
          const dataItems = this.unitCategory.suggestions.filter(item => item.date === currentDate.format('YYYY-MM-DD') && item.stop_sell !== 1);

          let data = null;

          if (dataItems.length > 0) {
            // Trova la suggerimento con il `min_stay` minimo
            data = dataItems.reduce((prev, curr) => (curr.min_stay < prev.min_stay ? curr : prev));
          }
          

          days.push({
            date: currentDate.format('YYYY-MM-DD'),
            month: currentDate.month() + 1,
            day_formatted: currentDate.format('DD MMM'),
            day_number: currentDate.format('DD'),
            day_month: currentDate.format('MMM'),
            is_future_date: currentDate.isAfter(this.$moment().subtract(1, 'day')),
            is_available: !!data?.availability || 0,
            cta: data?.cta,
            ctd: data?.ctd,
            min_stay: data?.min_stay,
            availability: data?.availability,
            amount: data?.amount,
            stop_sell: !!data?.stop_sell,
            week_day: currentDate.isoWeekday(),
          });

          currentDate.add(1, 'day');
        }

        return days;
      },

      isSelecting() {
        return !!this.selectedStartDate || !!this.selectedEndDate;
      },
      selectableDates() {
        if (!this.isSelecting) {
            return [];
        }

        const index = this.suggestionCalendar.findIndex(
            item => item.date === this.selectedStartDate
        );
        const minSelectableDate = this.$moment(this.selectedStartDate).add(
            this.selectedStartDateMinStay,
            'days'
        );

        const data = [];
        const datesToProcess = this.suggestionCalendar.slice(index);

        for (let i = 0; i < datesToProcess.length; i++) {
            const currentDate = datesToProcess[i];

            if (currentDate.separator) {
                continue;
            }

            if (currentDate.ctd) {
                continue;
            }

            if (!this.$moment(currentDate.date).isSameOrAfter(minSelectableDate)) {
                continue;
            }

            data.push(currentDate.date);

            if (!currentDate.availability || !currentDate.is_future_date) {
                break;
            }
        }

        return data;
    }
    },
  };
